module.exports = __webpack_public_path__ + "img/gj_4.acd62ee4.jpg";